class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('[id^="ModalClose-"]').forEach((item) => {
      item.addEventListener("click", this.hide.bind(this));
    });
    this.addEventListener("keyup", (event) => {
      if (event.code?.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
    this.hasVideoEmbeded = this.dataset.video === "true";
    this.preventClose = this.getAttribute("data-prevent-close") === "true";
  }

  show(opener, preventClose = false) {
    if (this.closest(".drawer__inner"))
      this.closest(".drawer__inner").style.transform = "none";
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    trapFocus(this, this.querySelector('[role="dialog"]'));

    this.preventClose = preventClose;
    if (preventClose) {
      this.setAttribute("data-prevent-close", true);
    }
    this.dispatchEvent(new CustomEvent("modal-loaded"));
  }

  clearErrors() {
    const errorElementSelector = this.querySelector(
      this.getAttribute("data-error-selector")
    );
    if (errorElementSelector) {
      errorElementSelector.setAttribute("hidden", true);
    }
    this.setAttribute("data-error", false);
  }

  shakeModal() {
    this.classList.add("popup-modal--shake");
    setTimeout(() => {
      this.classList.remove("popup-modal--shake");
    }, 100);
  }

  hide(removeOverflow = true) {
    if (this.preventClose) {
      this.shakeModal();
      return;
    }
    const openedModals = document.querySelectorAll(
      "modal-dialog[open], popup-modal"
    );
    if (openedModals.length >= 1 && removeOverflow) {
      document.body.classList.remove("overflow-hidden");
    }
    this.removeAttribute("open");
    if (this.closest(".drawer__inner"))
      this.closest(".drawer__inner").style.removeProperty("transform");
    removeTrapFocus(this.openedBy);
    this.clearErrors();
    if (this.hasVideoEmbeded) {
      this.querySelectorAll("video").forEach((video) => video.pause());
    }
    this.dispatchEvent(new CustomEvent("modal-closed"));
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("[data-cta-modal]");
    this.modal = document.querySelector(this.getAttribute("data-modal"));
    if (this.dataset.autoOpen === "true") {
      this.delay = this.dataset.delay * 1000 || 0;
      this.mainProduct = this.closest("main-product");
      if (this.mainProduct)
        this.mainProduct.replacementProductModalHasShown = true;
      this.autoShowTimeout = setTimeout(() => {
        this.LoadAndOpenModal();
      }, this.delay);
    }
    if (!this.button && this.dataset.autoOpen !== "true") return;
    if (this.dataset.targetUrl) {
      this.targetUrl = this.dataset.targetUrl;
    }
    if (this.dataset.targetElement) {
      this.targetElement = this.dataset.targetElement;
    }
    this.button.addEventListener("click", async (e) => {
      await this.LoadAndOpenModal(e);
    });
  }
  async LoadAndOpenModal(evt = null) {
    if (evt) evt.preventDefault();
    if (
      this.button?.hasAttribute("data-upsell-modal") ||
      this.dataset.autoOpen === "true"
    ) {
      await this.appendCartUpsell();
    }
    this.modal = document.querySelector(this.getAttribute("data-modal"));
    if (this.targetUrl && this.targetElement) {
      window.loaders = window.loaders || {};
      this.currentUrl = this.targetUrl;
      if (this.dataset.subPath) {
        this.currentUrl = this.targetUrl + this.dataset.subPath;
      }
      if (!window.loaders[this.currentUrl]) {
        await this.fetchSectionData();
      }
      const html = await window.loaders[this.currentUrl];
      if (!html) return;
      this.renderData(html);
    }
    if (this.modal) {
      this.modal.show();
      if (this.button?.hasAttribute("data-upsell-type")) {
        const form = this.modal.querySelector("product-form");
        if (form) {
          form.setAttribute("data-upsell-type", this.button.dataset.upsellType);
        }
      }
      if (this.isRechargeEnabled()) {
        this.initRechargeWidget();
      }
    }
  }
  isRechargeEnabled() {
    return this.dataset.recharge && window.ReChargeWidget;
  }
  initRechargeWidget() {
    const config = {
      productId: this.dataset.productId,
      injectionParent: `#product-form-${this.dataset.productId}`,
      injectionMethod: "prepend",
      selectors: {
        price: [`.current-price`],
        variant: [".variant-selector"],
      },
    };
    window.ReChargeWidget.createWidget(config);
  }

  fetchCartUpsell() {
    return new Promise(async (resolve) => {
      const resText = await apiFetchText(
        "",
        "?section_id=upsell-modal-container"
      );
      const upsellWrapper = document.getElementById(
        "Cart-upsell-modal-container"
      );
      if (upsellWrapper) {
        upsellWrapper.innerHTML = resText;
      }
      resolve(resText);
    });
  }

  async appendCartUpsell() {
    this.modal = document.querySelector(this.getAttribute("data-modal"));
    if (!window.cartUpsell) {
      showLoader();
      window.cartUpsell = await this.fetchCartUpsell();
      showLoader(false);
      return;
    }
    const upsellWrapper = document.getElementById(
      "Cart-upsell-modal-container"
    );
    if (upsellWrapper) {
      upsellWrapper.innerHTML = window.cartUpsell;
    }
  }

  renderData(html) {
    const content = html.querySelector(`${this.targetElement}`);
    if (content) {
      if (this.dataset.contentId) {
        document.querySelector(this.dataset.contentId).innerHTML =
          content.innerHTML;
      } else {
        this.modal.innerHTML = content.innerHTML;
      }
    }
  }

  async fetchSectionData() {
    showLoader();
    window.loaders[this.currentUrl] = new Promise(async (resolve) => {
      const res = await apiFetchText(this.currentUrl, "");
      const html = new DOMParser().parseFromString(res, "text/html");
      showLoader(false);
      resolve(html);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class PopupModal extends ModalDialog {
  constructor() {
    super();
    this.cookieName = this.dataset.cookie;
    this.resolve = null;
  }

  async show(opener, preventClose) {
    super.show(opener, preventClose);
    return new Promise((resolve) => {
      this.resolve = resolve;
    });
  }

  hide(removeOverflow = true) {
    super.hide(removeOverflow);
    theme.cookies = getCookie("popupModals")
      ? JSON.parse(getCookie("popupModals"))
      : {};
    theme.cookies[this.cookieName] = true;
    setCookie("popupModals", JSON.stringify(theme.cookies));
    this.resolve();

    layerPush({
      event: "loadMarketingApps",
    });
  }
}
customElements.define("popup-modal", PopupModal);
class ConfirmModal extends HTMLElement {
  constructor() {
    super();
    this.messageContainer = this.querySelector(
      ".subscription__confirm-warning"
    );
    this.confirmButton = this.querySelector(".confirm-btn");
    this.cancelButtons = this.querySelectorAll(".cancel-btn");
    this.cancelButtons.forEach((btn) =>
      btn.addEventListener("click", () => this.hide())
    );
  }
  hide() {
    this.removeAttribute("open");
    document.body.classList.remove("overflow-hidden");
  }
  show(message = null) {
    let _this = this;
    document.body.classList.add("overflow-hidden");
    const currentMessage = this.messageContainer.innerHTML;
    if (message) this.messageContainer.innerHTML = message;
    _this.setAttribute("open", "true");
    return new Promise((resolve) => {
      this.confirmButton.focus();
      this.confirmButton.addEventListener("click", () => {
        _this.removeAttribute("open");
        resolve(true);
        this.messageContainer.innerHTML = currentMessage;
        document.body.classList.remove("overflow-hidden");
      });
      this.cancelButtons.forEach((btn) =>
        btn.addEventListener("click", () => {
          _this.removeAttribute("open");
          resolve(false);
          this.messageContainer.innerHTML = currentMessage;
          document.body.classList.remove("overflow-hidden");
        })
      );
    });
  }
}
customElements.define("confirm-modal", ConfirmModal);
